<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Login</h4>
  <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="close('Cross click')"></button>
</div>
<div class="modal-body">
  <div class="login-box__form">
    <form [formGroup]="loginForm" (ngSubmit)="submit_loginform(loginForm.value)" class="ng-pristine ng-invalid ng-touched">
      <div class="form-group">
        <label class="organisation-head-text">
          <span>Username</span><span class="required"></span>
        </label>
        <input autofocus="" class="form-group__control ng-pristine ng-invalid ng-touched" formControlName="username" required type="text">
      </div>
      <div class="form-group">
        <label class="organisation-head-text">
          <span>Password</span><span class="required"></span>
        </label>
        <input class="form-group__control ng-untouched ng-pristine ng-invalid" formControlName="password" required type="password">
      </div>
      <div class="form-group-fp">
        <a class="fp" (click)="open_reset_password(reset_password);">
          Forgot your Password?
        </a>
        <a class="fp" (click)="openRegister(register)">
          Not Registered?
        </a>
      </div>     
      <div class="form-actions">
        <button class="button button--dark-blue" type="submit" value="Login" (click)="close('Cross click')" [disabled]="!loginForm.valid">
          Login
        </button>
      </div>   
    </form>
  </div>
</div>

<ng-template #register>
  <app-register (close_model)="close_register($event)"></app-register>
</ng-template>

<ng-template #reset_password>
  <app-password-reset (close)="close_reset_password($event)" (completed)="reset_password_complete($event)"></app-password-reset>
</ng-template>
